// extracted by mini-css-extract-plugin
module.exports = {"productForm":"ProductForm_productForm__p_uIO","alternative":"ProductForm_alternative__P84Og"};